import { InteractionType } from '@azure/msal-browser'
import { environment } from '@appEnvironments/environment'

const apiConfig = environment.apiConfig
const authorityDomain = apiConfig.authorityDomain

export const B2C_TENANT = 'swfcb2c.onmicrosoft.com'
export const B2C_Authority_URL = `https://${authorityDomain}/${B2C_TENANT}`

export enum B2CAuthority_ {
   defaultSignIn = 'defaultSignIn',
   //usernameSignIn = 'usernameSignIn',
   workAccountSignUpSignIn = 'workAccountSignUpSignIn'
}

export interface b2cAuthority {
   authority: string
}

const userFlows = apiConfig.userFlows

export const b2cAuthorities = new Map<B2CAuthority_, b2cAuthority>([
   [B2CAuthority_.defaultSignIn, {
      authority: `${B2C_Authority_URL}/${userFlows.defaultSignIn}`
   }],
   //[B2CAuthority_.usernameSignIn, {
   //   authority: `${B2C_Authority_URL}/${userFlows.usernameSignIn}`
   //}],
   [B2CAuthority_.workAccountSignUpSignIn, {
      authority: `${B2C_Authority_URL}/${userFlows.workAccountSignUpSignIn}`
   }]
])

export const defaultSignInAuthority = b2cAuthorities.get(B2CAuthority_.defaultSignIn)
//export const usernameSignInAuthority = b2cAuthorities.get(B2CAuthority_.usernameSignIn)
export const workAccountSignUpSignInAuthority = b2cAuthorities.get(B2CAuthority_.workAccountSignUpSignIn)
export const defaultB2CAuthority: b2cAuthority = defaultSignInAuthority

export const b2cPolicies = {
   names: {
      defaultSignIn: B2CAuthority_.defaultSignIn,
      //usernameSignIn: B2CAuthority_.usernameSignIn,
      workAccountSignUpSignIn: B2CAuthority_.workAccountSignUpSignIn,
   },
   authorities: {
      [B2CAuthority_.defaultSignIn]: defaultSignInAuthority,
      //[B2CAuthority_.usernameSignIn]: usernameSignInAuthority,
      [B2CAuthority_.workAccountSignUpSignIn]: workAccountSignUpSignInAuthority
   },
   authorityDomain: authorityDomain
}

export const b2cInteractionType = InteractionType.Redirect
